export default __webpack_public_path__ + "static/media/promo-icon-bottom-nav-mobile.cf32c360.webp";